import { render, staticRenderFns } from "./PoPickupModal.vue?vue&type=template&id=975e8dfc"
import script from "./PoPickupModal.vue?vue&type=script&lang=js"
export * from "./PoPickupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports